import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadCollaboratorsError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'twg-microsite.collaborationTop5.title',
		defaultMessage: 'Who are your top collaborators?',
		description: 'Title displayed above the top collaborators leaderboard',
	},
	emptyStateTitle: {
		id: 'twg-microsite.collaborationTop5.emptyStateTitle',
		defaultMessage: 'You have no top collaborators',
		description:
			'Title shown when the current user has no collaborators in their Teamwork Graph for the last 30 days',
	},
	emptyStateSubtitle: {
		id: 'twg-microsite.collaborationTop5.emptyStateSubtitle',
		defaultMessage:
			'Once you start working with teammates, your top collaborators from the last 30 days will appear here',
		description:
			'Subtitle shown when the current user has no collaborators, encouraging them to collaborate so the leaderboard populates',
	},
	loadCollaboratorsError: {
		id: 'twg-microsite.collaborationTop5.loadCollaboratorsError',
		defaultMessage: 'Error loading collaboration users',
		description: 'Error message shown when the list of top collaborators fails to load',
	},
});
